export const PROJECTS =[
  {
  title: "Airbnb Clone",
  icon: "🏡",
  desc: "A full-stack Airbnb clone that allows users to browse, add, and manage property listings. Features include user authentication, dynamic data rendering, and a responsive UI. Implemented CRUD operations with a backend server and integrated database for storing listings and user data.",
  tags: ["React", "Node.js", "Express.js", "EJS", "MongoDB", "REST API"],
  code: "https://github.com/avnishsingh309/airbnb-clone",
  demo: "https://airbnb-clone-steel-zeta.vercel.app/",
},
{
    title: "Tic Tac Toe — React",
    icon: "⚛",
    desc: "Classic Tic Tac Toe game built in React with clean UI, real-time gameplay logic and win detection.",
    tags: ["React", "JavaScript"],
    code: "https://github.com/avnishsingh309/tic-tac-toe-react",
    demo: "https://avnishsingh309.github.io/tic-tac-toe/",
  },
  {
    title: "Credit Card Fraud Detection",
    icon: "💳",
    desc: "ML project to detect fraudulent credit card transactions using Python and Scikit-learn with data preprocessing.",
    tags: ["Python", "ML", "Scikit-learn", "Pandas"],
    code: "https://github.com/avnishsingh309/Credit-Card-Fraud-Detection",
    demo: null,
  },
  {
    title: "To-Do List",
    icon: "✅",
    desc: "A dynamic task manager with add/delete functionality using pure JavaScript. Supports local state persistence.",
    tags: ["HTML", "CSS", "JavaScript"],
    code: "https://github.com/avnishsingh309/to-do-list",
    demo: "https://avnishsingh309.github.io/to-do-list/",
  },
  {
    title: "Weather Forecast",
    icon: "🌦",
    desc: "A weather app built with HTML, CSS, and JavaScript that fetches real-time weather data using a public weather API.",
    tags: ["HTML", "CSS", "JavaScript", "API"],
    code: "https://github.com/avnishsingh309/Weather-forecast",
    demo: "https://avnishsingh309.github.io/weather-forecast/",
  },

  {
    title: "QR Code Generator",
    icon: "📱",
    desc: "Generates QR codes instantly from user input using HTML, CSS, JavaScript and QR code API.",
    tags: ["HTML", "CSS", "JavaScript", "API"],
    code: "https://github.com/avnishsingh309/QR-Code-generator-",
    demo: "https://avnishsingh309.github.io/QR-Code-generator-/",
  },
  {
    title: "Quiz App",
    icon: "🧠",
    desc: "Interactive quiz application using JavaScript. Evaluates answers and gives instant feedback with score tracking.",
    tags: ["HTML", "CSS", "JavaScript"],
    code: "https://github.com/avnishsingh309/quiz",
    demo: "https://avnishsingh309.github.io/quiz/",
  },
  
  
  {
    title: "Random Password Generator",
    icon: "🔐",
    desc: "Generates secure random passwords with selectable length and character sets including symbols and numbers.",
    tags: ["HTML", "CSS", "JavaScript"],
    code: "https://github.com/avnishsingh309/random-password-generator-",
    demo: "https://avnishsingh309.github.io/random-password-generator-/",
  },
];

export const SKILLS = [
  { name: "HTML5",      icon: "⟨/⟩", color: "#e34f26", bg: "rgba(227,79,38,0.1)" },
  { name: "CSS3",       icon: "✦",   color: "#264de4", bg: "rgba(38,77,228,0.1)" },
  { name: "JavaScript", icon: "JS",  color: "#f7df1e", bg: "rgba(247,223,30,0.1)" },
  { name: "React",      icon: "⚛",   color: "#61dafb", bg: "rgba(97,218,251,0.1)" },

  { name: "Node.js",    icon: "⬢",   color: "#3c873a", bg: "rgba(60,135,58,0.1)" },
  { name: "Express.js", icon: "🚂",   color: "#ffffff", bg: "rgba(255,255,255,0.07)" },

  { name: "MongoDB",    icon: "🍃",   color: "#47a248", bg: "rgba(71,162,72,0.1)" },
  { name: "MySQL",      icon: "🛢️",  color: "#00758f", bg: "rgba(0,117,143,0.1)" },

  { name: "Python",     icon: "Py",  color: "#3776ab", bg: "rgba(55,118,171,0.1)" },
  { name: "Java",       icon: "☕",   color: "#f89820", bg: "rgba(248,152,32,0.1)" },

  { name: "C++",        icon: "C++", color: "#00599c", bg: "rgba(0,89,156,0.1)" },
  { name: "C",          icon: "C",   color: "#a8b9cc", bg: "rgba(168,185,204,0.1)" },

  { name: "Git",        icon: "🔧",   color: "#f1502f", bg: "rgba(241,80,47,0.1)" },
  { name: "GitHub",     icon: "🐙",   color: "#ffffff", bg: "rgba(255,255,255,0.07)" },

  { name: "DSA",        icon: "🧠",   color: "#ff6f61", bg: "rgba(255,111,97,0.1)" }
];

export const SKILL_BARS = [
  { name: "HTML & CSS" },
  { name: "JavaScript" },
  { name: "React" },
  { name: "Python" },
  { name: " C++" },
  { name: "Git & GitHub" },
  { name: "Node.js" },
  { name: "Express.js" },
  { name: "MongoDB" },
  { name: "MySQL" },
  { name: "REST API" },
  { name: "Bootstrap" },
  { name: "Tailwind CSS" },
  { name: "Responsive Design" },
  { name: "JSON" },
  { name: "VS Code" },
  { name: "Data Structures" },
  { name: "Problem Solving" }
];

export const SOCIALS = [
  { label: "GitHub",     short: "GH", url: "avnishsingh309",          href: "https://github.com/avnishsingh309",                       color: "#ffffff" },
  { label: "LinkedIn",   short: "in", url: "avnish-singh-168258252",   href: "https://www.linkedin.com/in/avnish-singh-168258252/",      color: "#0077b5" },
  { label: "LeetCode",   short: "LC", url: "avnishsingh309",           href: "https://leetcode.com/u/avnishsingh309/",                   color: "#ffa116" },
  { label: "Twitter / X",short: "X",  url: "@avnishs74628637",         href: "https://x.com/avnishs74628637",                            color: "#1da1f2" },
];

export const TYPEWRITER_TITLES = [
  "Web Developer",
  "UI Designer",
  "React Developer",
  "BTech CS Student",
  "ML Enthusiast",
];
